function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useContext } from 'react';
import { twMerge } from '@stereoagency/tailwind-config';
import ReactConfigContext from '../../ReactConfigContext';
export default function Breadcrumbs(param) {
    var actions = param.actions, className = param.className;
    var _useContext = useContext(ReactConfigContext), LinkComponent = _useContext.config.LinkComponent;
    return /*#__PURE__*/ React.createElement("div", {
        className: twMerge('flex justify-start items-center', className)
    }, actions.map(function(action, index) {
        return /*#__PURE__*/ React.createElement("span", {
            key: action.href,
            className: "font-body text-label-base font-semibold"
        }, /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({}, action), {
            className: twMerge('text-link-fg-base', index === actions.length - 1 && 'text-fg-base')
        })), !(index === actions.length - 1) && /*#__PURE__*/ React.createElement("span", {
            className: "mx-3"
        }, "/"));
    }));
}

//# sourceMappingURL=Breadcrumbs.js.map